import { render, staticRenderFns } from "./Form20SecretaryResolution.vue?vue&type=template&id=7f8f6b54&scoped=true&"
import script from "./Form20SecretaryResolution.vue?vue&type=script&lang=js&"
export * from "./Form20SecretaryResolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8f6b54",
  null
  
)

export default component.exports